import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from '../ui/Container';
import { Button } from '../ui/Button';

const NotFoundPage = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4">
      <Container variant="narrow">
        <div className="text-center">
          {/* 404 Number */}
          <h1 className="text-[120px] md:text-[180px] font-extrabold text-primary leading-none mb-4">
            404
          </h1>

          {/* Error Message */}
          <h2 className="text-2xl md:text-3xl font-bold text-text-primary mb-4">
            Page Not Found
          </h2>

          <p className="text-base md:text-lg text-text-secondary mb-8 max-w-md mx-auto">
            Sorry, we couldn't find the page you're looking for. The page may have been moved or deleted.
          </p>
        </div>
      </Container>
    </div>
  );
};

export default NotFoundPage;